// ---
// Breakpoints defined in css
let BREAKPOINTS;
(function () {
    BREAKPOINTS = {
        'xs' : Number(getComputedStyle(document.documentElement).getPropertyValue('--width-xs').replace(/\D/g, "")),
        'sm' : Number(getComputedStyle(document.documentElement).getPropertyValue('--width-sm').replace(/\D/g, "")),
        'md' : Number(getComputedStyle(document.documentElement).getPropertyValue('--width-md').replace(/\D/g, "")),
        'lg' : Number(getComputedStyle(document.documentElement).getPropertyValue('--width-lg').replace(/\D/g, "")),
        'xl' : Number(getComputedStyle(document.documentElement).getPropertyValue('--width-xl').replace(/\D/g, "")),
        'xxl' : Number(getComputedStyle(document.documentElement).getPropertyValue('--width-xxl').replace(/\D/g, "")),
    };
})();

// ---
// Vh and Vw vars set dynamically
(function() {
    const setViewportVariables = ( e ) => {
        // use `clientWidth` and `clientHeight` for dimensions without scrollbars
        document.documentElement.style.setProperty('--vh', `${document.documentElement.clientHeight/100}px`)
        document.documentElement.style.setProperty('--vw', `${document.documentElement.clientWidth/100}px`)
    }

    setViewportVariables();
    window.addEventListener( 'resize', setViewportVariables );
})();

// ---
// Show current screen on frontend in label
(function () {
    if (!window.location.href.includes('dev'))
        return;

    const div = document.createElement('div');
    div.id = "screen-size-indicator";
    document.body.append(div);
    const show_current_screen = () => {

        const div = document.getElementById('screen-size-indicator');
        if (!div) return;

        if ( window.innerWidth < BREAKPOINTS.sm ) {
            div.innerHTML = '< sm';
        } else if ( window.innerWidth > BREAKPOINTS.sm && window.innerWidth < BREAKPOINTS.md ) {
            div.innerHTML = 'sm - md';
        } else if ( window.innerWidth > BREAKPOINTS.md && window.innerWidth < BREAKPOINTS.lg ) {
            div.innerHTML = 'md - lg';
        } else if ( window.innerWidth > BREAKPOINTS.lg && window.innerWidth < BREAKPOINTS.xl ) {
            div.innerHTML = 'lg - xl';
        } else if ( window.innerWidth > BREAKPOINTS.xl ) {
            div.innerHTML = 'xl - full';
        }

    }
    window.addEventListener('resize', show_current_screen);
    show_current_screen();
})();

// ---
// Slider home
(function () {
    const swiper = new Swiper('.slider-banner', {
        slidesPerView: 'auto',
        autoplay: 3000,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });
})();

// ---
// Slider portfolio
(function () {
    new Swiper('.slider-portfolio', {
        slidesPerView: 1,
        spaceBetween: 20,
        // autoplay: true,
        loop: true,
        // autoHeight: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            }
        }
    });
})();

// ---
// Slider clients
(function () {
    new Swiper('.slider-clients', {
        spaceBetween: 40,
        autoplay: true,
        loop: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loopedSlides: 1,
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                loopedSlides: 4,
                slidesPerView: 4,
            }
        }
    });
})();

// ---
// Slider partners
(function () {
    new Swiper('.slider-partners', {
        spaceBetween: 40,
        autoplay: true,
        loop: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loopedSlides: 1,
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                loopedSlides: 4,
                slidesPerView: 4,
            }
        }
    });
})();

// ---
// Slider home
(function () {
    new Swiper('.slider-aquaprint-before', {
        slidesPerView: 1,
        autoplay: 3000,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    new Swiper('.slider-aquaprint-after', {
        slidesPerView: 1,
        autoplay: 3000,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
})();

// Slider franchise
(function () {
    new Swiper('.slider-franchise', {
        slidesPerView: 1,
        autoplay: 3000,
        spaceBetween: 30,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1140: {
                slidesPerView: 3,
            },
            782: {
                slidesPerView: 2,
            }
        }
    });
})();

// ---
// Class body when scroll
(function () {
    const $header_bar = document.querySelector('.header__bar');
    if (!$header_bar)
        return;

    window.addEventListener('scroll', () => {
        if (window.scrollY > 60) {
            document.body.classList.add('scrolled')
        } else {
            document.body.classList.remove('scrolled')
        }
    });
})();

// ---
// Video php shortcode
(function() {
    const $modal = document.getElementById('videoModal');
    if (!$modal) return;

    [].forEach.call( document.getElementsByClassName( 'video-canvas' ), function ( $video ) {
        const $pre = $video.querySelector( 'pre' );
        if ( !$pre ) return; // invalid or already attached

        const iframe = '<' + $pre.innerHTML + '>';
        $pre.remove();

        $video.addEventListener( 'click', function () {
            const $modal_body = $modal.querySelector('.youtube-video');

            if (!$modal_body)
                return;

            $modal_body.innerHTML = iframe; // insert video iframe
        } );
    } );

    $modal.addEventListener('hidden.bs.modal', function (event) {
        const $iframe = event.target.querySelector('iframe');
        if (!$iframe) return;
        $iframe.remove();
    })
})();

// ---
// Btn video
(function () {
    return;
    const $videos = document.querySelectorAll('.video-container');
    if (!$videos.length) return;

    const $modal = document.getElementById('videoModal');
    if (!$modal) return;

    // When modal was closed
    $modal.addEventListener('hidden.bs.modal', function (event) {
        const $iframe = event.target.querySelector('iframe');
        if (!$iframe) return;
        $iframe.setAttribute('src', '');
    })

    // Add link to iframe attribute when click button
    $videos.forEach( el => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const video_link = e.target.dataset.video;
            const $iframe = $modal.querySelector('iframe');
            if (!video_link || !$iframe) return;

            $iframe.setAttribute('src', video_link);
        })
    })
})();

// ---
// Scroll to top
(function () {
    const $btn_top = document.getElementById('scrollToTop');
    if (!$btn_top)
        return;

    $btn_top.addEventListener('click', e => {
        window.scrollTo(0, 0);
    })

})();